import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { VenueService } from '../services/venue.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-venue-create',
  templateUrl: './venue-create.component.html',
  styleUrls: ['./venue-create.component.css']
})
export class VenueCreateComponent implements OnInit {

  @ViewChild('form') form: NgForm;

  isSavingInfo: boolean = false;
  successMessage: string = "";
  errorMessage: string = "";

  newVenue: Partial<Venue> = {
    name: '',
    venue_description: '',
    capacity: 0,
    tables: 0,
    private_client: false,
    test_venue: false,
    zone: 0,
    phone: '',
    address: '',
    city: '',
    state: '',
    zip_code: '',
    site_url: '',
    facebook: '',
    twitter: '',
    instagram: ''
  };

  quillConfiguration = {
		toolbar: [
		  ['bold', 'italic', 'underline'],
		  ['blockquote'],
		  [{ list: 'ordered' }, { list: 'bullet' }],
		  [{ header: [1, 2, 3, 4, 5, 6, false] }],
		  ['link'],
		  ['clean'],
		],
	};

  constructor(private venueService: VenueService, private router: Router) { }

  ngOnInit(): void {
  }

  saveVenue(form: NgForm) {
    if (form.valid) {
      this.isSavingInfo = true;
      this.successMessage = "";

      const payload = {
        "venue_name": this.newVenue?.name,
        "venue_url": this.newVenue?.site_url,
        "venue_description": this.newVenue?.venue_description ?? "",
        "capacity": this.newVenue?.capacity,
        "tables": this.newVenue?.tables,
        "private_client": this.newVenue?.private_client,
        "test_venue": this.newVenue?.test_venue,
        "zone": this.newVenue?.zone,
        "venue_phone": this.newVenue?.phone,
        "venue_address": this.newVenue?.address,
        "venue_city": this.newVenue?.city,
        "venue_state": this.newVenue?.state,
        "venue_zip": this.newVenue?.zip_code,
        "venue_facebook": this.newVenue?.facebook,
        "venue_twitter": this.newVenue?.twitter,
        "venue_instagram": this.newVenue?.instagram
      }


      this.venueService.createVenue(payload).subscribe({
        next: (res: Venue) => {
          this.isSavingInfo = false;
          this.successMessage = "Venue created successfully!";
          this.resetForm();
          this.router.navigate([`/venues/${res.kt_venue_id}/details`]);
        },
        error: (err) => {
          console.error(err);
          this.isSavingInfo = false;
          this.errorMessage = "Error creating venue. Please try again.";
        }
      });
    }
  }

  resetForm() {
    this.newVenue = {
      name: '',
      venue_description: '',
      capacity: 0,
      tables: 0,
      private_client: false,
      test_venue: false,
      zone: 0,
      phone: '',
      address: '',
      city: '',
      state: '',
      zip_code: '',
      site_url: '',
      facebook: '',
      twitter: '',
      instagram: ''
    };
    this.successMessage = "";
    this.errorMessage = "";
  }

}
